export default __webpack_public_path__ + "static/AseoInd_7-e09cc19a49de511b1c557bfab4580692.png";